import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useUser } from 'components/Accounts';
import { Card } from 'components/Card';
import { RequestDemoContent } from './RequestDemo';
import { Input } from 'components/Form';
import { Button } from 'components/Button';

import styles from 'styles/Card.module.css';

// const SubmissionSuccessContent = () => {
//     return (
//         <>
//             <header>
//                 <h1>Submission Successful</h1>
//             </header>
//             <section>
//                 <p>Thank you! We will be in contact with you shortly. We look forward to having you as our customer!</p>
//             </section>
//         </>
//     )
// }

const LoginContent = ({ setIsRequested }) => {
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm();
    const { login } = useUser();
    const [errMessage, setErrMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const onSubmit = ({ email, password }) => {
        setLoading(true);
        login({ email, password }).then((res) => {
            if (res && res.message) {
                setLoading(false);
                setErrMessage(res.message);
            }
        });
    };

    return (
        <>
            <header>
                <h1 className={styles.login}>Login</h1>
            </header>
            <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
                <Input
                    type='email'
                    label='email'
                    placeholder='Email'
                    register={register}
                    required
                    errors={errors}
                    watch={watch}
                />
                <Input
                    type='password'
                    label='password'
                    placeholder='Password'
                    register={register}
                    required
                    errors={errors}
                    watch={watch}
                />
                {errMessage !== '' && (
                    <p className='err' data-cy='login-err-msg'>
                        {errMessage}
                    </p>
                )}
                <Button
                    uitype='cta'
                    color='primary-dark'
                    size='lg'
                    fullwidth
                    isLoading={loading}
                >
                    Log In
                </Button>
                <div className={styles.footer}>
                    <Link to='/reset-password'>Forgot Password?</Link>
                </div>
                {/* <div className={styles.requestFooter}>
                    <p>Don't Have An Account?</p>
                    <a onClick={() => setIsRequested(true)}>Request Demo</a>
                </div> */}
            </form>
        </>
    );
};

export const LoginCard = () => {
    const [isRequested, setIsRequested] = useState(false);

    return (
        <Card wide={isRequested}>
            {!isRequested ? (
                <LoginContent setIsRequested={setIsRequested} />
            ) : (
                <RequestDemoContent />
            )}
        </Card>
    );
};
